<div class="extra-large-screen doc-check-login-page {{partnerName}}">
    <div class="absolute-loading" *ngIf="showLoading">
        <div class="lds-ripple"><div></div><div></div></div>
    </div>
    <div class="login-form-section">
        <div class="login-form-container">
            <div class="login-form-header">
                <ng-container [ngSwitch]="partnerName">
                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_TILRAY">
                        <a href="/dosis-eq/tilray" class="m-0 text-center d-block w-100">
                            <img style="width:200px;" src="/images/private/titration/tilray/Logo.svg" alt="Logo.svg" />
                        </a>
                    </ng-container>
                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_HORMOSAN">
                        <a href="/dosis-eq/hormosan" class="m-0 text-center d-block w-100">
                            <img style="width:200px;" src="/images/private/titration/hormosan/Hormosan Logo.svg" alt="Logo.svg" />
                        </a>
                    </ng-container>
                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_420_PHARMA">
                        <a href="/dosis-eq/420pharma" class="m-0 text-center d-block w-100">
                            <img style="width:200px;" src="/images/private/420pharma/Logo.svg" alt="Logo.svg" />
                        </a>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <a href="/">
                            <img src="/Copeia.svg" alt="Copeia" />
                        </a>
                        <div>
                            <h4>Zugang für medizinisches Fachpersonal</h4>
                        </div>
                    </ng-container>
                </ng-container>
               
            </div>
            <div class="login-form-content">
                <ng-container [ngSwitch]="true">
                    <ng-container *ngSwitchCase="(partnerName==PartnerNamesEnum.DOSIS_EQ_TILRAY || partnerName==PartnerNamesEnum.DOSIS_EQ_HORMOSAN || partnerName==PartnerNamesEnum.DOSIS_EQ_420_PHARMA)">
                        <div class="mb-4">
                            <h5 class="text-center">Zugang für medizinisches Fachpersonal</h5>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      
                    </ng-container>
                </ng-container>
                <div class="docheck-container">
                    <div class="doccheck_login">
                        <iframe align="left" frameborder="0" scrolling="no" [attr.width]="DocCheckWidth" [attr.height]="DocCheckHeight" name="dc_login_iframe" id="dc_login_iframe" [src]="DocCheckLoginUrl"><a href="javascript:void(0);" [href]="DocCheckLoginUrl" target="_blank">LOGIN</a></iframe>
                    </div>
                </div>


                <div class="unlocked-section-footer">
                    <div class="unlocked-section">
                        <ng-container [ngSwitch]="partnerName">
                            <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_HORMOSAN">
                                <img src="/images/icons/Data_unlocked_white.svg" alt="Data_unlocked.svg" />
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <img src="/images/icons/Data_unlocked.svg" alt="Data_unlocked.svg" />
                            </ng-container>
                        </ng-container>
                        <h6>Datenschutz</h6>
                        <ng-container [ngSwitch]="partnerName">
                            <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_TILRAY">
                                <p>Diese Webseite nutzt die Technologie der Copeia GmbH. Die Copeia GmbH ist Herstellerin der Webseite, des bereitgestellten Software-Tools und der dahinter stehenden Technologie. Die Tilray Deutschland GmbH betreibt diese Webseite zur Präsentation ihrer Produkte als Lizenznehmerin der Copeia GmbH.</p>
                            </ng-container>
                            <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_HORMOSAN">
                                <p>Diese Webseite nutzt die Technologie der Copeia GmbH. Die Copeia GmbH ist Herstellerin der Webseite, des bereitgestellten Software-Tools und der dahinter stehenden Technologie. Die Hormosan Pharma GmbH betreibt diese Webseite zur Präsentation ihrer Produkte als Lizenznehmerin der Copeia GmbH.</p>
                            </ng-container>
                            <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_420_PHARMA">
                                <p>Diese Webseite nutzt die Technologie der Copeia GmbH. Die Copeia GmbH ist Herstellerin der Webseite, des bereitgestellten Software-Tools und der dahinter stehenden Technologie. Die Four 20 Pharma GmbH betreibt diese Webseite zur Präsentation ihrer Produkte als Lizenznehmerin der Copeia GmbH.</p>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <p>Diese Webseite nutzt die Technologie der Copeia GmbH. Der Schutz ihrer Daten hat für uns höchste Priorität. Die von Ihnen getätigten Angaben werden von uns nicht erfasst.</p>
                            </ng-container>
                        </ng-container>
                    </div>
                    <div class="footer-link">
                        <ul>
                            <li>
                                <ng-container [ngSwitch]="partnerName">
                                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_TILRAY">
                                        <a href="/dosis-eq/tilray/datenschutz">Datenschutz</a>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_HORMOSAN">
                                        <a href="/dosis-eq/hormosan/datenschutz">Datenschutz</a>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_420_PHARMA">
                                        <a href="/dosis-eq/420pharma/datenschutz">Datenschutz</a>
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        <a href="/datenschutz">Datenschutz</a>
                                    </ng-container>
                                </ng-container>
                            </li>
                            <li>
                                <a href="mailto:{{partnerEmail}}">Kontakt</a>
                            </li>
                        </ul>
                        <div class="text-right"><small>© Copeia GmbH, {{fullYear}}</small></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
